import script from "./HelpBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpBar.vue?vue&type=script&setup=true&lang=js"

import "./HelpBar.vue?vue&type=style&index=0&id=edd15198&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edd15198"]])

export default __exports__